export default __webpack_public_path__ + "static/about-video-poster-a86b4cb40261bc9c0e7bc8139000f40b.jpg";